<template>
  <div class="md:w-screen md:max-h-screen bg-neutral-white">
    <div class="dashboard-layout-collapsed">
      <div class="md:p-6 overflow-hidden">
        <div
          class="border-solid border-neutral-300 rounded-lg md:max-h-full overflow-hidden"
          :style="{
            boxShadow: '0px 8px 32px 0px #00000029',
          }"
        >
          <div class="border-b border-solid border-neutral-300 px-4 md:px-8 py-4 flex items-center justify-between">
            <div class="flex items-center gap-1">
              <PulseIconButton icon="LineTimes" variant="secondary" size="large" class="mr-2" @click="handleExit" />
              <slot name="title" />
            </div>

            <div class="flex items-center gap-4">
              <slot name="actions" />
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-[450px_1fr] h-[calc(100vh-7rem)]">
            <div class="border-r border-solid border-neutral-300 overflow-auto">
              <slot name="sidepanel" />
            </div>
            <div ref="content" class="transition-all ease-in-out overflow-auto scrollbar-hidden">
              <slot name="preview" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <UnsavedChangesModal
    :open="showUnsavedChangesModal"
    @close="showUnsavedChangesModal = false"
    @discard="handleDiscard"
  />
</template>

<script setup lang="ts">
const showUnsavedChangesModal = ref(false);

const props = defineProps<{
  exitUrl: string;
  unsavedChanges: boolean;
}>();

// Handle beforeunload event for page refresh/close
onMounted(() => {
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    if (props.unsavedChanges) {
      // Show a browser warning
      event.preventDefault();
      event.returnValue = '';

      return '';
    }
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  // Cleanup on unmount
  onUnmounted(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  });
});

function handleExit() {
  if (props.unsavedChanges) {
    showUnsavedChangesModal.value = true;

    return;
  }

  navigateTo(props.exitUrl ?? `/claims`);
}

function handleDiscard() {
  showUnsavedChangesModal.value = false;
  navigateTo(props.exitUrl ?? `/claims`);
}
</script>

<style lang="scss">
.dashboard-layout-collapsed {
  @screen md {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  @screen lg {
    @apply h-screen overflow-hidden;
  }

  @apply grid overflow-hidden; // this will need to change
}

.fill-current {
  svg {
    fill: currentColor;
  }
}

.scrollbar-hidden {
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
